<div>
	<div [ngClass]="{
		'text-center flex flex-col': true,
		'min-h-[80vh]': isMobile,
		'min-h-[200px]': !isMobile
	}">
		<div class="flex justify-center">
			<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34" />
				<path
					d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
					fill="#E94444" />
			</svg>
		</div>
		<div class="m-t-16">
			<div class="success-title">
				<ng-content></ng-content>
			</div>
		</div>
		<div [ngClass]="{
			'mt-[6px]': true,
			'grow md:grow-0': !shouldShowOptionalDescription
		}">
			<div class="success-des">
				<ng-content select="[description]"></ng-content>
			</div>
		</div>
		<div *ngIf="shouldShowOptionalDescription" class="m-t-6">
			<div class="success-des">
				<ng-container [ngTemplateOutlet]="optionalDescription.templateRef"></ng-container>
			</div>
		</div>

		<div>
			<ng-content select="[note]"></ng-content>
		</div>
		<div [ngClass]="{
			'm-t-16 flex flex-col gap-[16px]': true,
			'mt-[calc(100vh-550px)] md:mt-[24px]': reason === 'FAULTY'
		}">
			<ng-container [ngSwitch]="reason">
				<ng-container *ngSwitchCase="'STOLEN'">
					<div class="grow basis-0" *ngIf="context === aggregators">
						<app-custom-button [isBlock]="true" text="Write-Off Terminal" (submitForm)="continue()">
						</app-custom-button>
					</div>
					<div class="grow basis-0">
						<app-custom-button [isBlock]="true" state="secondary" text="Dismiss" (submitForm)="cancelModal(false)">
						</app-custom-button>
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="'FAULTY'">
					<div class="grow basis-0">
						<app-custom-button [isBlock]="true" text="Proceed" (submitForm)="cancelModal(true)">
						</app-custom-button>
					</div>
					<div class="grow basis-0">
						<app-custom-button [isBlock]="true" state="secondary" text="Cancel" (submitForm)="cancelModal(false)">
						</app-custom-button>
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="'OTHERS'">
					<ng-container *ngTemplateOutlet="buttonsSection"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="'BUSINESS_REQUESTED_FOR_POS_CHANGE'">
					<ng-container *ngTemplateOutlet="buttonsSection"></ng-container>
				</ng-container>
			</ng-container>
		</div>
	</div>
</div>
<ng-template #buttonsSection>
	<div class="grow basis-0">
		<app-custom-button [isBlock]="true" state="secondary" text="Cancel" (submitForm)="cancelModal(false)">
		</app-custom-button>
	</div>
</ng-template>